<div class="spen-ly-modal" id="modal">
  <div class="modal-dialog">
    <div class="inner">
      <div class="modal-heading">
        @if (layoutService.isTabletDownView.value) {
          <div class="btn-close">
            <a (click)="onClose()">
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>
          </div>
        }
        <h2 class="heading-text">公開先の選択</h2>
      </div>

      <div class="scrollable-modal-content">
        <div
          class="modal-content"
          infinite-scroll
          infiniteScrollDistance="1"
          infiniteScrollThrottle="200"
          [infiniteScrollDisabled]="!nextPageParams"
          [scrollWindow]="false"
          (scrolled)="onLoadMore()"
        >
          <div class="spaces-input">
            <input
              class="spen-mod-input-text"
              maxlength="30"
              type="text"
              [placeholder]="layoutService.isTabletDownView.value ? 'キーワードを入力' : 'キーワードを入力してください'"
              #searchInput
            />
            <button class="spen-mod-btn" (click)="onSearch(true)">
              {{ layoutService.isTabletDownView.value ? '検索' : '検索する' }}
            </button>
          </div>
          @if (isShowError) {
            <div class="spen-mod-error-content error-popup">スペースを選択してください</div>
          }

          <div class="list-header">
            <h3>スペースリスト</h3>
          </div>

          <div class="spaces-list" [class.border-bottom-none]="searchedResults.length === 0 && !isLoading">
            @for (space of searchedResults; track space.id) {
              <div
                class="space-item"
                (change)="selectSpace(space)"
                [class.has-hover-effect]="!layoutService.isTabletDownView.value && !canNotPickup(space)"
              >
                <label class="spen-mod-checkbox" [class.is-disabled]="canNotPickup(space)">
                  <input
                    class="checkbox"
                    type="checkbox"
                    [checked]="isSelectedSpace(space) && !canNotPickup(space)"
                    [disabled]="canNotPickup(space)"
                  />
                  <i class="fa"></i>
                  <div class="block-color" [style.background-color]="space.color_code"></div>
                  @if (!layoutService.isTabletDownView.value) {
                    <p class="truncate-text space-name">
                      {{ space.name }}
                      @if (!space.teacher_can_pick_up) {
                        <span>（ピックアップ制限中）</span>
                      }
                      @if (space.is_picked_up_by_current_teacher) {
                        <span>（ピックアップ表示中）</span>
                      }
                    </p>
                  } @else {
                    <div class="fix-width-label-name">
                      <p class="truncate-text space-name">{{ space.name }}</p>
                      <p class="note-small">
                        @if (!space.teacher_can_pick_up) {
                          <span>（ピックアップ制限中）</span>
                        }
                        @if (space.is_picked_up_by_current_teacher) {
                          <span>（ピックアップ表示中）</span>
                        }
                      </p>
                    </div>
                  }
                </label>
              </div>
            }

            @if (isLoading) {
              <div class="spen-mod-flex-loading">
                <div class="loading-icon"></div>
              </div>
            }
          </div>
          @if (!isLoading && searchedResults.length === 0) {
            <div class="empty-message">
              {{ errorMsg || '検索結果が0件です。' }}
            </div>
          }
        </div>
        <div class="modal-footer">
          <div class="full-width">
            <button class="spen-mod-btn is-default" (click)="onClose()">キャンセル</button>
            <button class="spen-mod-btn is-primary" (click)="onSubmit()" [disabled]="isShowError">選択する</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
